<div class="card mt-3">
  <div class="card-header">Suggest List</div>
  <div class="card-body">

    <div class="form-group"><label><input type="checkbox" [(ngModel)]="loading"> Loading</label></div>
    <div class="form-group"><label><input type="checkbox" [(ngModel)]="readonly"> readonly</label></div>
    <div class="form-group"><label><input type="checkbox" [(ngModel)]="disabled"> disabled</label></div>

    <div>
      <label>Drop Down List</label>
      <qpoint-suggestlist
        [dropdownDefaultItem]="defaultItem"
        [dropDownVariant]="dropDownVariant.DropDownList"
        textField="value"
        valueField="key"
        [data]="items"
        placeholder="test"
        [filterable]="false"
        [isLoading]="loading"
        [disabled]="disabled"
        [hasMoreEntries]="true"
        [dropdownListClearable]="true"
        [valuePrimitive]="false"
        [readonly]="readonly"
      >
        <ng-template qpointSuggestlistValueTemplate let-dataItem>
          {{ dataItem?.key}}
        </ng-template>
      </qpoint-suggestlist>

      <label class="test">Drop Down List Grouped With Styled Header</label>
      <qpoint-suggestlist
        [dropDownVariant]="dropDownVariant.ComboBox"
        [dropdownDefaultItem]="null"
        [allowCustom]="true"
        [isLoading]="loading"
        [data]="groupedItems"
        [readonly]="readonly"
        [disabled]="disabled"
        textField="value"
        valueField="key"
      >
        <ng-template qpointSuggestlistDetailTemplate let-dataItem>
          <div>
            Entry: {{ dataItem?.key}}
          </div>
        </ng-template>

        <ng-template qpointSuggestListGroupTemplate let-item>
          <div>
            <span>Group header: {{ item }}</span>
          </div>
        </ng-template>
      </qpoint-suggestlist>

      <label>Combobox</label>
      <qpoint-suggestlist
        [dropDownVariant]="dropDownVariant.ComboBox"
        textField="value"
        valueField="key"
        [data]="items"
        placeholder="test"
        [isLoading]="loading"
        [disabled]="disabled"
        [readonly]="readonly"
      >
      </qpoint-suggestlist>

      <label>Combobox with custom values</label>
      <qpoint-suggestlist
        [dropDownVariant]="dropDownVariant.ComboBox"
        textField="value"
        valueField="key"
        [data]="items"
        placeholder="test"
        [disabled]="false"
        [readonly]="false"
        [allowCustom]="true"
      >
      </qpoint-suggestlist>

      <label>Combobox FormControl (with Filter implemented)</label>
      <qpoint-reactive-form-input-group [qpointFormControl]="suggestListFormControl" [isSubmitted]="true">
        <qpoint-suggestlist
          [dropDownVariant]="dropDownVariant.ComboBox"
          textField="value"
          [data]="filteredItems"
          placeholder="test"
          valueField="key"
          [formControl]="suggestListFormControl"
          [isLoading]="loading"
          [disabled]="disabled"
          [readonly]="readonly"
          [preselectSingleItem]="false"
          (filterChange)="suggestListFilterChanged($event)"
        >
        </qpoint-suggestlist>
      </qpoint-reactive-form-input-group>


      <label>Combobox with single item preselect</label>
      <qpoint-suggestlist
        [dropDownVariant]="dropDownVariant.ComboBox"
        textField="value"
        valueField="key"
        [data]="[items[0]]"
        placeholder="test"
        [isLoading]="loading"
        [disabled]="disabled"
        [readonly]="readonly"
        [preselectSingleItem]="true"
      >
      </qpoint-suggestlist>  

      <label>Multiselect</label>
      <qpoint-suggestlist
        [dropDownVariant]="dropDownVariant.MultiSelect"
        textField="value"
        valueField="key"
        [data]="items"
        placeholder="test"
        [isLoading]="loading"
        [disabled]="disabled"
        [hasMoreEntries]="true"
        [readonly]="readonly"
      >
      </qpoint-suggestlist>

      <label>Checkbox List</label>
      <qpoint-checkbox-list
        textField="key"
        [data]="items"
        [isLoading]="loading"
        [disabled]="disabled"
        [readonly]="readonly"
      >
      </qpoint-checkbox-list>
    </div>
  </div>
</div>
